// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.action-btn {\n  text-transform: capitalize;\n  letter-spacing: normal;\n  line-height: normal !important;\n  margin-right: 7px;\n  margin-top: 5px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
